export const env: { [s: string]: (string | null); } = {
  'npm_package_name': 'autentique-frontend',
  'npm_package_version': '2.0.0',
  'GIT_HEAD': 'bea6c639d4676c28a6346df246c8bfe5519a88b2',
  'CUR_DATE': '3007261107'
};
